import { useState, useEffect } from 'react';
import './DashboardOverview.css';

/**
 * Dashboard Overview Component
 * Shows key metrics and statistics for super admin
 */

function DashboardOverview({ apiBase }) {
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalAdmissions: 0,
    pendingApprovals: 0,
    activeContent: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, [apiBase]);

  const fetchStats = async () => {
    try {
      // Fetch users
      const usersRes = await fetch(`${apiBase}/admin/users`, {
        credentials: 'include',
      });
      const usersData = usersRes.ok ? await usersRes.json() : { data: [] };

      // Fetch admissions
      const admissionsRes = await fetch(`${apiBase}/admin/admissions/applications`, {
        credentials: 'include',
      });
      const admissionsData = admissionsRes.ok ? await admissionsRes.json() : { data: [] };

      setStats({
        totalUsers: usersData.data?.length || 0,
        totalAdmissions: admissionsData.data?.length || 0,
        pendingApprovals: admissionsData.data?.filter(a => a.status_code === 'submitted').length || 0,
        activeContent: 0,
      });
    } catch (err) {
      console.error('Error fetching stats:', err);
    } finally {
      setLoading(false);
    }
  };

  const cards = [
    {
      title: 'Total Users',
      value: stats.totalUsers,
      color: 'card-blue',
      trend: '+5 this month',
    },
    {
      title: 'Total Admissions',
      value: stats.totalAdmissions,
      color: 'card-green',
      trend: stats.pendingApprovals + ' pending',
    },
    {
      title: 'Pending Review',
      value: stats.pendingApprovals,
      color: 'card-yellow',
      trend: 'Action needed',
    },
    {
      title: 'Active Content',
      value: stats.activeContent,
      color: 'card-purple',
      trend: 'Published',
    },
  ];

  return (
    <div className="dashboard-overview">
      <div className="content-header">
        <h2 className="content-title">Dashboard Overview</h2>
        <p className="content-subtitle">System statistics and key metrics</p>
      </div>

      {/* Stat Cards */}
      <div className="stats-grid">
        {cards.map((card, index) => (
          <div key={index} className={`stat-card ${card.color}`}>
            <div className="card-label">{card.title}</div>
            <div className="card-value">{loading ? '-' : card.value}</div>
            <div className="card-trend">{card.trend}</div>
          </div>
        ))}
      </div>

      {/* Recent Activities */}
      <div className="recent-section">
        <h3>Recent Activities</h3>
        <div className="activity-list">
          <div className="activity-item">
            <div className="activity-type">User Registration</div>
            <div className="activity-info">
              <p className="activity-text">New user registered</p>
              <small>2 hours ago</small>
            </div>
          </div>
          <div className="activity-item">
            <div className="activity-type">Content Review</div>
            <div className="activity-info">
              <p className="activity-text">Content awaiting approval</p>
              <small>4 hours ago</small>
            </div>
          </div>
          <div className="activity-item">
            <div className="activity-type">Approval</div>
            <div className="activity-info">
              <p className="activity-text">Application approved</p>
              <small>1 day ago</small>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="quick-actions">
        <h3>Quick Actions</h3>
        <div className="actions-grid">
          <button className="action-btn">
            Add User
          </button>
          <button className="action-btn">
            View Admissions
          </button>
          <button className="action-btn">
            Publish Content
          </button>
          <button className="action-btn">
            System Settings
          </button>
        </div>
      </div>
    </div>
  );
}

export default DashboardOverview;
